module.exports = __webpack_public_path__ + "static/media/img_26.6757a5ac.png";